'use client'

import React, { memo } from 'react'

/**
 * Version simplifiée de PanelElement pour les grandes mires
 * Utilisé automatiquement quand il y a > 200 panneaux
 * Réduit drastiquement la complexité du rendu SVG
 */

interface SimplePanelElementProps {
  element: any
  panel: any
  isSelected: boolean
  isDragging: boolean
  onClick: (element: any) => void
  onContextMenu?: (e: React.MouseEvent, element: any) => void
}

const SimplePanelElement = memo(({
  element,
  panel,
  isSelected,
  isDragging,
  onClick,
  onContextMenu
}: SimplePanelElementProps) => {
  
  return (
    <g
      onClick={() => onClick(element)}
      onContextMenu={(e) => {
        if (onContextMenu) {
          e.preventDefault()
          onContextMenu(e, element)
        }
      }}
      style={{ cursor: 'pointer' }}
      opacity={isDragging ? 0.5 : (element.data?.opacity !== undefined ? element.data.opacity : 1)}
    >
      {/* Rectangle simple */}
      <rect
        x={element.position.x}
        y={element.position.y}
        width={element.size.width}
        height={element.size.height}
        fill={isSelected ? '#3b82f6' : '#1e293b'}
        stroke={isSelected ? '#2563eb' : '#475569'}
        strokeWidth={isSelected ? 1.5 : 0.5}
        rx={1}
      />
      
      {/* Les numéros ne sont pas affichés sur les grandes mires pour des raisons de performance */}
    </g>
  )
})

SimplePanelElement.displayName = 'SimplePanelElement'

export default SimplePanelElement

